// components
import Text from "components/atoms/Text/Text";
import IconWithLabel from "components/atoms/IconWithLabel/IconWithLabel";
import SideNavInputSearch from "components/atoms/SideNavInputSearch/SideNavInputSearch";

// styles
import styles from "components/molecules/SideNavigationMenu/sideNavigationMenu.module.css";
import theme from "styles/theme";

// utils
import { IconType } from "utils/getIcon";

// types
import { To } from "react-router-dom";
import { NavigationMenuItem } from "containers/Home/useHome";
import { OutletItem } from "services/api/types";

// constants
import { SideNavConstants } from "constants/sidenavigation";

type SideNavigationMenuPropTypes = {
	isAdminUser: boolean;
	activeMenu: number;
	menusToRender: NavigationMenuItem[];
	outlets: Array<OutletItem>;
	handleMenuClick: (menuId: number, redirectedPath: To | To[]) => void;
};

const SideNavigationMenu = ({ isAdminUser, outlets, activeMenu, menusToRender, handleMenuClick }: SideNavigationMenuPropTypes): JSX.Element => {
	return (
		<div className={styles?.root}>
			{isAdminUser && (
				<div className={styles.title}>
					<Text textContent="Admin Portal" style={{ color: theme.colors.violet }} />
				</div>
			)}
			{!isAdminUser && outlets.length > 1 && <SideNavInputSearch placeholder={SideNavConstants.INPUT_PLACEHOLDER} outlets={outlets} />}

			<div className={styles.container}>
				{menusToRender?.map(({ icon, label, route, id, showDivider }, index) => {
					// Handle both single ID and array of IDs
					const menuId = Array.isArray(id) ? id[0] : id;
					const isActive = Array.isArray(id) ? id.includes(activeMenu) : id === activeMenu;

					// Handle both single route and array of routes
					const menuRoute = Array.isArray(route) ? route[0] : route;

					return (
						<div key={`${menuId}-${index}`}>
							{showDivider ? (
								<div className={styles.divider} />
							) : (
								<IconWithLabel icon={{ icon: icon as IconType }} data-testid={label} label={label} onClickHandler={() => handleMenuClick(menuId, menuRoute)} isActive={isActive} />
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default SideNavigationMenu;
